// extracted by mini-css-extract-plugin
export default {"mainContainer":"KickCounter_mainContainer__Pxtyr","gridContainer":"KickCounter_gridContainer__GSwqM"};